import type { ComponentType, ReactNode } from 'react'

/**
 * Nests `wrappers` around `children`, last-entry-innermost — the array
 * reads outermost-to-innermost, same order as writing the JSX nesting by
 * hand (e.g. `[InvalidateOnOrgChange, TooltipProvider]` renders
 * `<InvalidateOnOrgChange><TooltipProvider>{children}</TooltipProvider></InvalidateOnOrgChange>`).
 */
export function composeWrappers(
  wrappers: Array<ComponentType<{ children: ReactNode }>> | undefined,
  children: ReactNode,
): ReactNode {
  if (!wrappers || wrappers.length === 0) return children
  return wrappers.reduceRight<ReactNode>(
    (acc, Wrapper) => <Wrapper>{acc}</Wrapper>,
    children,
  )
}
